.mobileFilterRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  margin-left: 16px;
  margin-right: 16px;
  overflow-x: scroll;
  padding-top: 8px;
  scrollbar-width: none; /* Firefox */
}

.mobileFilterRow::-webkit-scrollbar {
  display: none;
}

.mobileActionSlot {
  display: contents;
}

@media all and (--reefer-media-tablet-min) {
  .mobileFilterRow {
    display: none;
  }

  .mobileActionSlot {
    display: none;
  }
}
